/* 🤖 this file was generated by svg-to-ts */
export const matIconCenterFocusStrong: {
  name: 'center-focus-strong';
  data: string;
} = {
  name: 'center-focus-strong',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5 5-2.24 5-5zm-5 3c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm-7 0H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"/></svg>`
};
